export default "__VITE_ASSET__DwdTum7$__"